<template>
  <div id="app" class="container-fluid">
    <mz-debug></mz-debug>
    <mz-navbar></mz-navbar>
    <router-view></router-view>        
  </div>
</template>

<script>
import Debug from '@/components/Debug'
import Navbar from '@/components/Navbar'

export default {
  name: 'app',
  data () {
    return {
    }
  },
  components: {
    mzDebug: Debug,
    mzNavbar: Navbar
  }
}
</script>

<style lang="scss">
@import "./theme/theme.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue